import { useEffect, useState } from 'react'
import {
  driverLocationsAPI,
  DriverLocation,
} from 'api/driverLocationsAPI'

interface Options {
  lat?: number
  lng?: number
  enabled?: boolean
}

export const useDriverLocations = ({
  lat,
  lng,
  enabled = true,
}: Options): DriverLocation[] => {
  const [drivers, setDrivers] = useState<DriverLocation[]>([])

  useEffect(() => {
    if (!enabled || typeof lat !== 'number' || typeof lng !== 'number') {
      setDrivers([])
      return undefined
    }

    let cancelled = false
    driverLocationsAPI
      .getDriverLocations(lat, lng)
      .then((res) => {
        if (cancelled) return
        setDrivers(res?.data?.value ?? [])
      })
      .catch(() => {
        if (cancelled) return
        setDrivers([])
      })

    return () => {
      cancelled = true
    }
  }, [lat, lng, enabled])

  return drivers
}

export default useDriverLocations
